import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
    Typography, Grid, Paper, Box, Container, useTheme, alpha 
} from '@mui/material';

// Importación de imágenes (Mantenemos tus rutas)
import icono_eventos from '../../assets/images/website/icono_eventos.png';
import icono_gastronomia from '../../assets/images/website/icono_gastronomia.png';
import icono_hospedaje from '../../assets/images/website/icono_hospedaje.png';
import icono_tiendas from '../../assets/images/website/icono_tiendas.png';
import icono_salud from '../../assets/images/website/icono_salud.png';
import icono_belleza from '../../assets/images/website/icono_belleza.png';
import icono_servicios from '../../assets/images/website/icono_servicios.png';
import icono_transporte from '../../assets/images/website/icono_transporte.png';
import icono_deporte from '../../assets/images/website/icono_deporte.png';
import icono_turismo from '../../assets/images/website/icono_turismo.png';

// Componente de Botón de Categoría Mejorado
function CategoryButton({ name, icon, onClick }) {
    const theme = useTheme();
    
    return (
        <Grid item xs={6} sm={4} md={3} lg={2.4}> {/* 5 columnas en pantallas grandes se ve genial */}
            <Paper 
                elevation={0}
                onClick={onClick}
                sx={{
                    p: 2,
                    cursor: 'pointer',
                    borderRadius: 3,
                    bgcolor: '#FFFFFF',
                    border: '1px solid',
                    borderColor: 'divider',
                    transition: 'all 0.2s ease-in-out',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100%',
                    '&:hover': {
                        transform: 'translateY(-5px)',
                        //borderColor: theme.palette.link.main,
                        boxShadow: `0 8px 20px ${alpha(theme.palette.primary.main, 0.15)}`
                    }
                }}
            >
                {/* Contenedor de imagen con fondo suave */}
                <Box sx={{ 
                    width: 70, 
                    height: 70, 
                    borderRadius: '50%', 
                    bgcolor: alpha(theme.palette.grey[200], 0.5),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2
                }}>
                    <img 
                        src={icon} 
                        alt={name} 
                        style={{ width: 45, height: 45, objectFit: 'contain' }} 
                    />
                </Box>
                
                <Typography 
                    variant="body1" 
                    fontWeight="600" 
                    textAlign="center"
                    sx={{ color: 'text.primary' }}
                >
                    {name}
                </Typography>
            </Paper>
        </Grid>
    );
}

export default function Categories() {
    const { t } = useTranslation();
    const history = useHistory();

    const redirect = (route) => history.push(route);

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Typography variant="h5" fontWeight="bold">
                    Explorar Categorías
                </Typography>
                {/* Aquí podrías poner un "Ver todo" si quisieras */}
            </Box>
            
            <Grid container spacing={2} sx={{ mb: 5 }}>
                
                <CategoryButton
                    icon={icono_eventos}
                    name={t('categories.events', 'Eventos')}
                    onClick={() => redirect('eventos')}
                />

                <CategoryButton
                    icon={icono_gastronomia}
                    name={t('categories.gastronomy', 'Gastronomía')}
                    onClick={() => redirect('search/Gastronomía')}
                />

                <CategoryButton
                    icon={icono_hospedaje}
                    name={t('categories.lodging', 'Hospedaje')}
                    onClick={() => redirect('search/Hospedaje')}
                />

                <CategoryButton
                    icon={icono_tiendas}
                    name={t('categories.shops', 'Tiendas')}
                    onClick={() => redirect('search/Tiendas')}
                />

                <CategoryButton
                    icon={icono_salud}
                    name={t('categories.health', 'Salud')}
                    onClick={() => redirect('search/Salud')}
                />

                <CategoryButton
                    icon={icono_belleza}
                    name={t('categories.beauty', 'Belleza')}
                    onClick={() => redirect('search/Belleza')}
                />

                <CategoryButton
                    icon={icono_servicios}
                    name={t('categories.services', 'Servicios')}
                    onClick={() => redirect('search/Servicios')}
                />

                <CategoryButton
                    icon={icono_transporte}
                    name={t('categories.transport', 'Transporte')}
                    onClick={() => redirect('search/Transporte')}
                />

                <CategoryButton
                    icon={icono_deporte}
                    name={t('categories.sports', 'Deportes')}
                    onClick={() => redirect('search/deportes')}
                />

                <CategoryButton
                    icon={icono_turismo}
                    name={t('categories.tourism', 'Turismo')}
                    onClick={() => redirect('search/turismo')}
                />
            </Grid>
        </Box>
    );
}